import utils from './../utils.js';
import platform from '../platform/index.js';
export default platform.hasStandardBrowserEnv ?
    // Standard browser envs support document.cookie
    {
        write: function (name, value, expires, path, domain, secure) {
            var cookie = [name + '=' + encodeURIComponent(value)];
            utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
            utils.isString(path) && cookie.push('path=' + path);
            utils.isString(domain) && cookie.push('domain=' + domain);
            secure === true && cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function (name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return (match ? decodeURIComponent(match[3]) : null);
        },
        remove: function (name) {
            this.write(name, '', Date.now() - 86400000);
        }
    }
    :
        // Non-standard browser env (web workers, react-native) lack needed support.
        {
            write: function () { },
            read: function () {
                return null;
            },
            remove: function () { }
        };
